import { useQuery } from '@apollo/client';
import { getNotificationTemplate } from '@/graph/notificationTemplates';

interface NotificationTemplate {
  content: string;
}

/**
 * Custom hook for fetching notification templates.
 * Replaces the legacy graphql(getNotificationTemplate) HOCs.
 *
 * @returns Object containing notification template messages
 */
export function useNotificationTemplates() {
  const { data: pickupData } = useQuery<{ getNotificationTemplate: NotificationTemplate[] }>(getNotificationTemplate, {
    variables: { trigger: 'FamilyReady' },
  });

  const { data: familyData } = useQuery<{ getNotificationTemplate: NotificationTemplate[] }>(getNotificationTemplate, {
    variables: { trigger: 'PatientReadyForFamily' },
  });

  return {
    patientPickupMessage: pickupData?.getNotificationTemplate?.[0]?.content || false,
    readyForFamilyMessage: familyData?.getNotificationTemplate?.[0]?.content || false,
  };
}
